﻿import React from 'react';
import { format } from 'date-fns';
import strings from 'assets/strings';
import classNames from 'classnames';

import Constant from 'utils/constants';
import { clientDashboardTour } from 'config/tour';
import { useLoggedInUser } from 'hooks';
import { useBranch } from 'components/BranchProvider';
import TaskListWidget from 'containers/TaskListWidget';
import ClientOverview from 'components/ClientOverview';
import GracePeriodFooter from 'components/GracePeriodFooter';
import { isGracePeriodActive } from 'helpers/user';

import theme from "./ClientDashboard.module.scss";

function ClientDashboard() {
  const user = useLoggedInUser();
  const [branch] = useBranch();
  const renderNextCheckInDate = () => {
    if (
      user?.program?.state !== Constant.stage.state.started ||
      !user.program.latest_stage ||
      user.program.latest_stage?.state === Constant.stage.state.completed
    ) {
      return null;
    }
    // A stage only gains check_in_scheduled when its check-in is scheduled, so a stage
    // that is merely published has none. Formatting that threw "RangeError: Invalid time
    // value" during render, and the client's whole dashboard was replaced by the error
    // fallback: they could see the navbar and nothing else. Found by the e2e suite on
    // 2026-09-17 against a seeded client in the stage_published state. Pre-existing, the
    // file is identical to origin/master apart from import paths, but React 19 makes a
    // render throw far more destructive than React 16 did.
    const scheduled = user.program.latest_stage.check_in_scheduled;
    const scheduledOn = scheduled ? new Date(scheduled) : null;
    if (!scheduledOn || Number.isNaN(scheduledOn.getTime())) {
      return null;
    }
    return (
      <h2 className={theme.NextCheckInDate}>
        Next Check-in Date: {format(scheduledOn, 'MMMM d, yyyy')}
      </h2>
    );
  };
  return (
    <div className={theme.dashboardRoot}>
      <div
        className={classNames(theme.dashboardContentContainer, {
          [theme.marginFooter]: isGracePeriodActive(user),
        })}
      >
        <div className={theme.dashboardGreeting}>
          <p>{strings.greet(user.profile.first_name || user.email)}</p>
          {renderNextCheckInDate()}
        </div>
        <div id={clientDashboardTour.tasks.id} className={theme.dashboardRow}>
          <TaskListWidget />
        </div>
        <div className={theme.dashboardRow}>
          <ClientOverview
            client={user}
            skipTreatmentPlan={branch.skip_treatment_plan}
          />
        </div>
      </div>
      {isGracePeriodActive(user) && <GracePeriodFooter />}
    </div>
  );
}

export default ClientDashboard;
